// Change my password (SPEC §7.8): current + new + repeat, for every role.

import { changePassword } from "../../api/auth";
import type { ApiResult } from "../../api/client";
import { t } from "../../i18n/i18n";
import { createButton, createElement } from "../../ui/dom";
import { createErrorBox, showProblem, showToast } from "../../ui/feedback";
import { createInputField, showFieldErrors, type Field } from "../../ui/forms";
import { startPage } from "../pageFrame";

export async function renderChangePasswordPage(container: HTMLElement): Promise<void> {
  const page: HTMLElement = startPage(container, t("password.title"));
  const current: Field<HTMLInputElement> = createInputField(t("password.current"), "password", "");
  const next: Field<HTMLInputElement> = createInputField(t("password.new"), "password", "");
  const repeat: Field<HTMLInputElement> = createInputField(t("password.repeat"), "password", "");
  const errorBox: HTMLDivElement = createErrorBox();
  const card: HTMLDivElement = createElement("div", "card");
  const save: HTMLButtonElement = createButton(t("app.save"), async (): Promise<void> => {
    if (next.input.value !== repeat.input.value) {
      repeat.error.textContent = t("password.mismatch");
      return;
    }

    const result: ApiResult<null> = await changePassword(current.input.value, next.input.value);
    showProblem(errorBox, result.ok ? null : result.problem);
    showFieldErrors(result.ok ? null : result.problem, { currentPassword: current, newPassword: next });
    if (result.ok) {
      showToast(t("password.changed"));
      clearInputs([current, next, repeat]);
    }
  }, "button-primary");
  card.append(current.wrapper, next.wrapper, repeat.wrapper, errorBox, save);
  page.append(card);
  return Promise.resolve();
}

function clearInputs(fields: Field<HTMLInputElement>[]): void {
  for (const field of fields) {
    field.input.value = "";
  }
}
